/* AP 6.0 — page « Guide des formats » (zone E) : simulateur à l'échelle. Sans dépendance ; utilise ap-frame.js (AP.setCadre, AP.framePrice, AP.money).
   Scènes réelles 1600×1200 (repères mesurés sur les images, repris de la démo V15) :
   cx = centre du meuble (% largeur), xcm = % de la largeur pour 1 cm au mur, top = haut du meuble (% hauteur) ; en hauteur 1 cm = xcm × 4/3 %.
   Largeur encadrée = largeur du poster / 0,9037 (fenêtre du visuel de cadre 592×814). Posters espacés de 6 cm, bas à 20 cm du meuble. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ap-sim]');
  if (!root || root.__ap) return; root.__ap = 1;
  var AP = window.AP || {}, T;
  try { T = JSON.parse(root.querySelector('[data-ap-sim-i18n]').textContent); } catch (e) { return; }
  var SC = {
    canape: { w: 210, cx: 49, xcm: .3173, top: 63 },
    lit: { w: 160, cx: 50, xcm: .267, top: 65.8 },
    bureau: { w: 140, cx: 50.4, xcm: .44, top: 66 }
  };
  var SZ = { M: [30, 42], L: [42, 60], XL: [60, 84] }, GAP = 6, LIFT = 20;
  var PRICE = { M: +root.dataset.pm || 0, L: +root.dataset.pl || 0, XL: +root.dataset.pxl || 0 };
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var stage = $('[data-ap-stage]'), bg = stage.querySelector('img');
  var cfgBtns = $$('[data-cfg]'), thBtns = $$('[data-th]');
  if (!cfgBtns.length) return;
  var S = { sc: 'canape', cfg: '', fr: 'noir', th: thBtns.length ? thBtns[0].dataset.th : '' };
  /* même format que le filtre Liquid | money (shop.money_format), pour que les prix recalculés ressemblent aux prix serveur */
  function fmtMoney(c, f) {
    var m = f && f.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return AP.money ? AP.money(c) : (c / 100).toFixed(2);
    function n(d, th, dec) { var p = (c / 100).toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dec + p[1] : ''); }
    var v = { amount: n(2, ',', '.'), amount_no_decimals: n(0, ',', '.'), amount_with_comma_separator: n(2, '.', ','), amount_no_decimals_with_comma_separator: n(0, '.', ','), amount_with_apostrophe_separator: n(2, "'", '.'), amount_with_space_separator: n(2, ' ', ','), amount_no_decimals_with_space_separator: n(0, ' ', ',') }[m[1]] || n(2, ',', '.');
    return f.replace(m[0], v);
  }
  var money = function (c) { return fmtMoney(c, root.dataset.money); };
  var fp = function (size, fr) { return fr && AP.framePrice ? AP.framePrice(size.toLowerCase(), fr) : 0; };

  function cols(btn) { return btn.dataset.cols.split(',').filter(Boolean).map(function (c) { return c.split('/').filter(function (x) { return SZ[x]; }); }).filter(function (c) { return c.length; }); }
  function outer(id, fr) { var w = fr ? SZ[id][0] / .9037 : SZ[id][0]; return [w, w * (fr ? 814 / 592 : 400 / 283)]; }
  /* positions en cm : x depuis le bord gauche de la composition, y depuis son bas ; chaque colonne est centrée verticalement */
  function layout(cs, fr) {
    var C = cs.map(function (col) {
      var its = col.map(function (id) { return { id: id, wh: outer(id, fr) }; });
      return { its: its, w: Math.max.apply(null, its.map(function (i) { return i.wh[0]; })), h: its.reduce(function (a, i) { return a + i.wh[1]; }, 0) + GAP * (its.length - 1) };
    });
    var W = C.reduce(function (a, c) { return a + c.w; }, 0) + GAP * (C.length - 1), H = Math.max.apply(null, C.map(function (c) { return c.h; }));
    var items = [], x = 0;
    C.forEach(function (col) {
      var y = (H - col.h) / 2 + col.h;
      col.its.forEach(function (it) { y -= it.wh[1]; items.push({ id: it.id, x: x + (col.w - it.wh[0]) / 2, y: y, w: it.wh[0], h: it.wh[1] }); y -= GAP; });
      x += col.w + GAP;
    });
    items.sort(function (a, b) { return b.w - a.w || a.x - b.x; }); // les plus grands reçoivent les premiers posters du thème
    return { W: W, H: H, items: items };
  }
  /* règle du guide : la composition couvre 1/2 à 2/3 de la largeur du meuble (tolérance 75 % avec les cadres) */
  function fit(btn) {
    var sc = SC[S.sc], L = layout(cols(btn), S.fr), r = L.W / sc.w, ycm = sc.xcm * 4 / 3;
    var bad = sc.top - LIFT * ycm - L.H * ycm < 6 || L.W * sc.xcm > 86;
    return { L: L, r: r, ok: !bad, tag: bad ? 'big' : r < .45 ? 'small' : r <= .75 ? 'ideal' : 'wide' };
  }
  function best() { var b = cfgBtns.filter(function (x) { return x.dataset.best === S.sc && fit(x).ok; })[0]; return (b || cfgBtns.filter(function (x) { return fit(x).ok; })[0] || cfgBtns[0]).dataset.cfg; }
  function btnOf(k) { return cfgBtns.filter(function (b) { return b.dataset.cfg === k; })[0]; }

  /* petites icônes des compositions (mêmes positions que la scène) */
  cfgBtns.forEach(function (b) {
    var L = layout(cols(b), ''), k = Math.min(38 / L.W, 30 / L.H), ox = (40 - L.W * k) / 2, oy = (30 - L.H * k) / 2;
    b.querySelector('.ap-gd-ico').innerHTML = L.items.map(function (i) {
      return '<i style="left:' + (ox + i.x * k).toFixed(1) + 'px;bottom:' + (oy + i.y * k).toFixed(1) + 'px;width:' + (i.w * k).toFixed(1) + 'px;height:' + (i.h * k).toFixed(1) + 'px"></i>';
    }).join('');
  });

  function pool() {
    var t = root.querySelector('template[data-pool="' + S.th + '"]') || root.querySelector('template[data-pool]');
    return t ? [].slice.call(t.content.children) : [];
  }
  function bundle(items) {
    var u = items.map(function (it) { return PRICE[it.id] + fp(it.id, S.fr); });
    var full = u.reduce(function (a, b) { return a + b; }, 0);
    var free = u.length >= 3 ? Math.min.apply(null, u) : 0; // un seul poster offert par commande
    return { full: full, pay: full - free, free: free > 0, n: u.length };
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render() {
    var sc = SC[S.sc], btn = btnOf(S.cfg), F = fit(btn), L = F.L, ycm = sc.xcm * 4 / 3, scb = root.querySelector('[data-sc="' + S.sc + '"]');
    $$('[data-sc]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.sc === S.sc)); });
    $$('[data-fr]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.fr === S.fr)); });
    thBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.th === S.th)); });
    $('[data-ap-rule]').textContent = T.rule.replace('%a', Math.round(sc.w / 2)).replace('%b', Math.round(sc.w * 2 / 3));
    cfgBtns.forEach(function (b) {
      var f = fit(b), isBest = b.dataset.best === S.sc, tag = b.querySelector('[data-tag]');
      b.disabled = !f.ok; b.setAttribute('aria-pressed', String(b.dataset.cfg === S.cfg));
      tag.className = isBest && f.ok ? 'ap-gd-best' : f.tag === 'ideal' ? 'ap-gd-ok' : '';
      tag.textContent = (isBest && f.ok ? T.tags.best : T.tags[f.tag]) + ' · ' + Math.round(f.L.W) + ' cm';
    });
    // image de la scène
    if (bg.dataset.sc !== S.sc && scb) {
      bg.dataset.sc = S.sc; bg.srcset = scb.dataset.img8 + ' 800w, ' + scb.dataset.img + ' 1600w'; bg.src = scb.dataset.img;
    }
    // posters : % de la largeur / hauteur de la scène
    var P = pool(), left0 = sc.cx - L.W * sc.xcm / 2, bot0 = 100 - sc.top + LIFT * ycm;
    stage.querySelectorAll('.ap-cg-sp,.ap-gd-dim,.ap-cg-flab').forEach(function (x) { x.remove(); });
    var frag = document.createDocumentFragment();
    L.items.forEach(function (it, i) {
      var src = P[i % (P.length || 1)]; if (!src) return;
      var a = src.cloneNode(true);
      a.style.left = (left0 + it.x * sc.xcm).toFixed(2) + '%';
      a.style.bottom = (bot0 + it.y * ycm).toFixed(2) + '%';
      a.style.width = (it.w * sc.xcm).toFixed(2) + '%';
      a.setAttribute('aria-label', (a.getAttribute('aria-label') || '') + ', ' + it.id);
      frag.appendChild(a);
    });
    var dim = document.createElement('span'); dim.className = 'ap-gd-dim';
    dim.style.left = left0.toFixed(2) + '%'; dim.style.width = (L.W * sc.xcm).toFixed(2) + '%';
    dim.style.bottom = 'calc(' + (bot0 + L.H * ycm).toFixed(2) + '% + 8px)';
    dim.innerHTML = '<span>' + Math.round(L.W) + ' cm</span>';
    var lab = document.createElement('span'); lab.className = 'ap-cg-flab';
    lab.textContent = (scb ? scb.dataset.name : '') + ' · ' + sc.w + ' cm';
    frag.appendChild(dim); frag.appendChild(lab);
    stage.appendChild(frag);
    if (AP.setCadre) AP.setCadre(S.fr, stage);
    // résultat : prix réel (format × cadre de chaque poster), le 3ᵉ offert
    var pr = bundle(L.items), isBest = btn.dataset.best === S.sc;
    var counts = {}; L.items.forEach(function (i) { counts[i.id] = (counts[i.id] || 0) + 1; });
    var fmts = ['XL', 'L', 'M'].filter(function (k) { return counts[k]; }).map(function (k) { return counts[k] + ' × ' + k; }).join(' + ');
    var p = T.res.replace('%s', Math.round(L.W) + ' × ' + Math.round(L.H) + ' cm').replace('%f', fmts).replace('%p', Math.round(F.r * 100)).replace('%w', sc.w);
    var suf = F.tag === 'ideal' ? T.suffix.ideal : F.tag === 'small' ? T.suffix.small : T.suffix.wide;
    var each = pr.free ? '<span class="ap-pill ap-pill-violet">' + esc(T.free) + '</span> ' + esc(T.each.replace('%p', money(Math.round(pr.pay / pr.n)))) : pr.n === 2 ? esc(T.add1) : pr.n === 1 ? esc(T.one) : '';
    $('[data-ap-res]').innerHTML =
      '<div><span class="ap-gd-kick">' + esc(isBest ? T.kick.best : F.tag === 'ideal' ? T.kick.ideal : T.kick.other) + '</span>' +
      '<h4>' + esc(btn.dataset.label) + ' · ' + esc(T.frames[S.fr]) + '</h4><p>' + esc(p + ' ' + suf) + '</p></div>' +
      '<div class="ap-gd-pr"><b>' + money(pr.pay) + '</b>' + (pr.free ? '<s>' + money(pr.full) + '</s>' : '') +
      '<span class="ap-gd-each">' + each + '</span>' +
      '<a class="ap-btn ap-btn-dark ap-btn-sm" href="' + esc(root.dataset.lot) + '">' + esc(T.cta) + '</a></div>';
  }

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-sc],[data-cfg],[data-fr],[data-th]');
    if (!t || t.disabled || !root.contains(t)) return;
    var d = t.dataset;
    if (d.sc) { S.sc = d.sc; S.cfg = best(); }            // changer de pièce = repartir de la composition conseillée
    else if (d.cfg) S.cfg = d.cfg;
    else if (d.fr !== undefined) { S.fr = d.fr; if (!fit(btnOf(S.cfg)).ok) S.cfg = best(); }
    else if (d.th) S.th = d.th;
    render();
  });
  S.cfg = best();
  render();
})();
